import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <div className="mb-6">
        <div className="w-20 h-20 relative flex items-center justify-center mx-auto mb-6">
          <div className="absolute inset-0 border border-primary-600/30 rounded-sm rotate-45" />
          <div className="absolute inset-2 border border-primary-700/20 rounded-sm rotate-45" />
          <div className="absolute inset-4 border border-primary-800/20 rounded-sm rotate-45" />
        </div>
      </div>
      <h1 className="font-heading text-6xl md:text-8xl font-bold text-primary-400 mb-4">
        404
      </h1>
      <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 mb-3">
        Page Not Found
      </h2>
      <p className="text-foreground-400 text-sm md:text-base mb-2 font-body">
        The page <span className="text-primary-400 font-mono">{location.pathname}</span> does not exist.
      </p>
      <p className="text-foreground-500 text-sm mb-8 font-body">
        It might have been moved or deleted.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold tracking-wider uppercase rounded-full hover:bg-primary-400 transition-colors"
      >
        <i className="ri-home-line" />
        Back to Home
      </Link>
    </div>
  );
}